const READ_MORE_SELECTOR = 'a.wp-block-read-more';

const handleReadMoreClick = (event) => {
    const readMoreLink = event.target.closest(READ_MORE_SELECTOR);

    if (!readMoreLink) {
        return;
    }

    event.preventDefault();
    readMoreLink.classList.toggle('show');
};

export default {
    init() {
        document.addEventListener('click', handleReadMoreClick);
    },
};
